module.exports = __webpack_public_path__ + "assets/img/fbb8cf33bdbf75962013e37935c7a09b.svg";